export default "__VITE_ASSET__Dmh8$VJG__"